import React, { FC, useEffect, useMemo } from 'react';
import { PremiumPrice } from 'src/api/internal/schema';
import { filterNulls } from 'src/utils/array';
import { PriceCard } from '../PriceCard';
import * as S from './styles';

export const PricesList: FC<{
  prices: PremiumPrice[];
  selectedPrice: PremiumPrice | null;
  setSelectedPrice: (price: PremiumPrice) => void;
  onDisplay?: (displayedPrices: PremiumPrice[]) => void;
}> = ({ prices, selectedPrice, setSelectedPrice, onDisplay }) => {
  const monthlyPlan = prices.find(p => p.paymentPeriod === 'month') || null;
  const yearlyPlan = prices.find(p => p.paymentPeriod === 'year') || null;
  const lifetimePlan = prices.find(p => p.paymentPeriod === 'lifetime') || null;

  const displayedPrices = useMemo(
    () => filterNulls([monthlyPlan, yearlyPlan, lifetimePlan]),
    [lifetimePlan, monthlyPlan, yearlyPlan],
  );

  useEffect(() => {
    if (!selectedPrice) {
      setSelectedPrice(yearlyPlan || displayedPrices[0]);
    }
  }, [selectedPrice, setSelectedPrice, yearlyPlan, displayedPrices]);

  useEffect(() => {
    if (displayedPrices.length > 0 && onDisplay) {
      onDisplay(displayedPrices);
    }
  }, [displayedPrices, onDisplay]);

  return (
    <S.ListWrapper>
      {displayedPrices.map(p => (
        <PriceCard
          key={p.paymentPeriod}
          selected={selectedPrice === p}
          price={p}
          showAsPopular={p.paymentPeriod === 'year'}
          onClick={() => setSelectedPrice(p)}
        />
      ))}
    </S.ListWrapper>
  );
};
